import React, { useEffect, useState } from 'react';
import BrowserFrame from './BrowserFrame';

const LogisticsMap: React.FC = () => {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1200);
    return () => clearInterval(id);
  }, []);

  const vehicles = [
    { id: 'TR-041', status: 'En transit', color: '#2E7D32', eta: `${12 - (tick % 4)} min` },
    { id: 'TR-017', status: 'En transit', color: '#2E7D32', eta: `${28 - (tick % 6)} min` },
    { id: 'TR-023', status: 'Livré', color: 'var(--blue)', eta: 'Terminé' },
    { id: 'TR-005', status: 'Retard', color: '#C62828', eta: '+18 min' },
  ];

  return (
    <BrowserFrame url="miid.app/fleet/live">
      <div style={{ padding: '1rem', background: 'var(--cream)', minHeight: '260px', fontFamily: "'Montserrat', sans-serif" }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '.8rem' }}>
          <div style={{ fontSize: '.72rem', fontWeight: 600, color: 'var(--ink)' }}>Tracking Flotte</div>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '.3rem' }}>
            <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#2E7D32', animation: 'livePulse 1.4s infinite' }} />
            <span style={{ fontSize: '.48rem', fontWeight: 700, color: '#2E7D32', letterSpacing: '.1em' }}>4 ACTIFS</span>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '.5rem' }}>
          {/* Map */}
          <div
            style={{
              background: 'var(--white)',
              border: '1px solid var(--border)',
              borderRadius: '4px',
              height: '200px',
              position: 'relative',
              overflow: 'hidden',
              backgroundImage:
                'linear-gradient(rgba(26,111,168,.06) 1px, transparent 1px), linear-gradient(90deg, rgba(26,111,168,.06) 1px, transparent 1px)',
              backgroundSize: '20px 20px',
            }}
          >
            <svg viewBox="0 0 280 200" style={{ width: '100%', height: '100%' }}>
              {/* Roads */}
              <path d="M 20 30 Q 100 40 140 100 T 260 170" stroke="rgba(26,111,168,.25)" strokeWidth="1.5" fill="none" />
              <path d="M 10 150 L 120 120 L 240 40" stroke="rgba(26,111,168,.25)" strokeWidth="1.5" fill="none" />
              <path d="M 50 180 L 140 100 L 220 100" stroke="rgba(26,111,168,.25)" strokeWidth="1.5" fill="none" />

              {/* Active route */}
              <path
                id="route1"
                d="M 20 30 Q 100 40 140 100 T 260 170"
                stroke="var(--blue)"
                strokeWidth="2"
                fill="none"
                strokeDasharray="4 3"
              />

              {/* Destinations */}
              <circle cx="20" cy="30" r="4" fill="var(--gold)" />
              <circle cx="260" cy="170" r="4" fill="var(--gold)" />
              <circle cx="240" cy="40" r="4" fill="var(--gold)" />

              {/* Moving vehicles */}
              <circle r="5" fill="#2E7D32" stroke="white" strokeWidth="1.5">
                <animateMotion dur="4s" repeatCount="indefinite" path="M 20 30 Q 100 40 140 100 T 260 170" />
              </circle>
              <circle r="5" fill="#2E7D32" stroke="white" strokeWidth="1.5">
                <animateMotion dur="3.5s" repeatCount="indefinite" path="M 10 150 L 120 120 L 240 40" />
              </circle>
              <circle r="5" fill="#C62828" stroke="white" strokeWidth="1.5">
                <animateMotion dur="5s" repeatCount="indefinite" path="M 50 180 L 140 100 L 220 100" />
              </circle>

              {/* Pulse rings */}
              <circle cx="140" cy="100" r="8" fill="none" stroke="var(--blue)" strokeOpacity=".4">
                <animate attributeName="r" values="8;18;8" dur="2s" repeatCount="indefinite" />
                <animate attributeName="opacity" values=".5;0;.5" dur="2s" repeatCount="indefinite" />
              </circle>
            </svg>
          </div>

          {/* Vehicle list */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '.3rem' }}>
            {vehicles.map((v) => (
              <div key={v.id} style={{ background: 'var(--white)', border: '1px solid var(--border)', padding: '.4rem .5rem', borderRadius: '4px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ fontSize: '.55rem', fontWeight: 700, color: 'var(--ink)' }}>{v.id}</div>
                  <div style={{ width: '5px', height: '5px', borderRadius: '50%', background: v.color }} />
                </div>
                <div style={{ fontSize: '.42rem', color: v.color, fontWeight: 600, letterSpacing: '.05em', textTransform: 'uppercase' }}>
                  {v.status}
                </div>
                <div style={{ fontSize: '.5rem', color: 'var(--ink2)', marginTop: '.15rem' }}>ETA: {v.eta}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </BrowserFrame>
  );
};

export default LogisticsMap;
